// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/payment/v1/requests.proto (package gportal.api.payment.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { PaymentProvider } from "../../../type/v1/payment_pb.js";
import { AddonSelection } from "./order_pb.js";
import { Region } from "../../../type/v1/region_pb.js";
import { Money } from "../../../type/v1/money_pb.js";
import { PaginationRequest } from "../../../type/v1/pagination_pb.js";

/**
 * How far a consume may go to collect what it was asked for.
 *
 * The two callers want opposite things and both are right, which is why this
 * is per call and not a server setting. A legacy renewal is a recurring
 * authorisation the customer signed up for: if the balance falls short, the
 * card they saved is what should pay the rest, and refusing instead
 * deactivates their server. The website's `pay_with_balance` checkout arm is
 * the reverse — a customer who chose "pay from my wallet" must never have a
 * card charged instead of it.
 *
 * Unspecified is balance-only, not fallback, for the reason the checkout oneof
 * is required rather than defaulted: a client bug that drops this field must
 * fail closed, and the closed direction is the one that cannot spend money the
 * customer did not offer.
 *
 * @generated from enum gportal.api.payment.v1.CollectionMode
 */
export enum CollectionMode {
  /**
   * @generated from enum value: COLLECTION_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Collect from the account balance alone. A shortfall is refused before any
   * invoice exists, and an invoice that turns out to have been settled by
   * anything other than the balance is unwound.
   *
   * @generated from enum value: COLLECTION_MODE_BALANCE_ONLY = 1;
   */
  BALANCE_ONLY = 1,

  /**
   * Collect from the account balance and let Chargebee charge the customer's
   * payment method for whatever is left. Chargebee applies excess before it
   * reaches the gateway, so the balance is always spent first; the card only
   * ever sees the shortfall. Refused up front when the customer has no usable
   * payment source, so this never silently degrades to BALANCE_ONLY's outcome
   * without saying which one happened.
   *
   * @generated from enum value: COLLECTION_MODE_BALANCE_THEN_PAYMENT_METHOD = 2;
   */
  BALANCE_THEN_PAYMENT_METHOD = 2,

  /**
   * Collect the whole amount from the payment source the customer chose
   * (`payment_source_id`, required), and nothing from the account balance. For
   * the legacy checkout, where picking a payment method over the balance is the
   * customer's choice. Balance Chargebee applied to the invoice by itself is
   * detached before the source is charged.
   *
   * @generated from enum value: COLLECTION_MODE_PAYMENT_METHOD_ONLY = 3;
   */
  PAYMENT_METHOD_ONLY = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(CollectionMode)
proto3.util.setEnumType(CollectionMode, "gportal.api.payment.v1.CollectionMode", [
  { no: 0, name: "COLLECTION_MODE_UNSPECIFIED" },
  { no: 1, name: "COLLECTION_MODE_BALANCE_ONLY" },
  { no: 2, name: "COLLECTION_MODE_BALANCE_THEN_PAYMENT_METHOD" },
  { no: 3, name: "COLLECTION_MODE_PAYMENT_METHOD_ONLY" },
]);

/**
 * Instrument a supporter grant is booked under. Carried on the wire so the
 * per-type VAT and revenue-recognition routing can change without a proto
 * change. Mirrors the Webinterface `payment_transactions.type` values offered
 * in the admin "Add Funds" dropdown.
 *
 * @generated from enum gportal.api.payment.v1.GrantType
 */
export enum GrantType {
  /**
   * @generated from enum value: GRANT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * `giveaway` — a gift, e.g. a marketing campaign.
   *
   * @generated from enum value: GRANT_TYPE_GIVEAWAY = 1;
   */
  GIVEAWAY = 1,

  /**
   * `boost-internal` — funds on an internal account for test purposes.
   *
   * @generated from enum value: GRANT_TYPE_BOOST_INTERNAL = 2;
   */
  BOOST_INTERNAL = 2,

  /**
   * `boost-partner` — a partner payout, e.g. the monthly referral revenue
   * share. The spending cap that used to be enforced by reading the account
   * balance is enforced against `promotional_credits` instead.
   *
   * @generated from enum value: GRANT_TYPE_BOOST_PARTNER = 3;
   */
  BOOST_PARTNER = 3,

  /**
   * `service-internal` — funds in return of a service provided, e.g. for
   * translators. Deliberately NOT routed to promotional credits: it is payment
   * for services rendered and promotional credits carry before-tax discount
   * semantics, which would under-recognise both the revenue and the cost. The
   * server refuses this type until that carve-out is answered; the value
   * exists so refusing it is explicit rather than an unknown-enum fallthrough.
   *
   * @generated from enum value: GRANT_TYPE_SERVICE_INTERNAL = 4;
   */
  SERVICE_INTERNAL = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(GrantType)
proto3.util.setEnumType(GrantType, "gportal.api.payment.v1.GrantType", [
  { no: 0, name: "GRANT_TYPE_UNSPECIFIED" },
  { no: 1, name: "GRANT_TYPE_GIVEAWAY" },
  { no: 2, name: "GRANT_TYPE_BOOST_INTERNAL" },
  { no: 3, name: "GRANT_TYPE_BOOST_PARTNER" },
  { no: 4, name: "GRANT_TYPE_SERVICE_INTERNAL" },
]);

/**
 * Why a previously credited amount is being taken back off the Chargebee
 * balance. The reason decides which reversal instruments the server may reach
 * for, not merely how the reversal is labelled.
 *
 * @generated from enum gportal.api.payment.v1.ReversalReason
 */
export enum ReversalReason {
  /**
   * @generated from enum value: REVERSAL_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Money returned to the customer on our initiative (Adyen/Stripe refund).
   * May be refused if the balance no longer covers it — refusing is better
   * than driving a balance negative.
   *
   * @generated from enum value: REVERSAL_REASON_REFUND = 1;
   */
  REFUND = 1,

  /**
   * Money taken back by the card scheme. Must always succeed: if the balance
   * no longer covers it the server raises an open clawback invoice, so the
   * debt shows up as a negative net rather than an unreconciled ledger row.
   *
   * @generated from enum value: REVERSAL_REASON_CHARGEBACK = 2;
   */
  CHARGEBACK = 2,

  /**
   * A supporter correcting a booking mistake (`correction` in the admin
   * dropdown). Same coverage rules as a refund.
   *
   * @generated from enum value: REVERSAL_REASON_CORRECTION = 3;
   */
  CORRECTION = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ReversalReason)
proto3.util.setEnumType(ReversalReason, "gportal.api.payment.v1.ReversalReason", [
  { no: 0, name: "REVERSAL_REASON_UNSPECIFIED" },
  { no: 1, name: "REVERSAL_REASON_REFUND" },
  { no: 2, name: "REVERSAL_REASON_CHARGEBACK" },
  { no: 3, name: "REVERSAL_REASON_CORRECTION" },
]);

/**
 * @generated from message gportal.api.payment.v1.GetManagementUrlRequest
 */
export class GetManagementUrlRequest extends Message<GetManagementUrlRequest> {
  /**
   * @generated from field: gportal.type.v1.PaymentProvider provider = 1;
   */
  provider = PaymentProvider.UNSPECIFIED;

  constructor(data?: PartialMessage<GetManagementUrlRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetManagementUrlRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "provider", kind: "enum", T: proto3.getEnumType(PaymentProvider) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetManagementUrlRequest {
    return new GetManagementUrlRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetManagementUrlRequest {
    return new GetManagementUrlRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetManagementUrlRequest {
    return new GetManagementUrlRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetManagementUrlRequest | PlainMessage<GetManagementUrlRequest> | undefined, b: GetManagementUrlRequest | PlainMessage<GetManagementUrlRequest> | undefined): boolean {
    return proto3.util.equals(GetManagementUrlRequest, a, b);
  }
}

/**
 * Request for progressive disclosure of order configuration options.
 * Fields are progressively filled as user makes selections.
 *
 * @generated from message gportal.api.payment.v1.GetOrderInformationRequest
 */
export class GetOrderInformationRequest extends Message<GetOrderInformationRequest> {
  /**
   * Chargebee plan ID (e.g. "Gamecloud-Farming-Simulator-2026")
   *
   * @generated from field: string plan_id = 1;
   */
  planId = "";

  /**
   * ISO 4217 currency code (e.g. "EUR")
   *
   * @generated from field: string currency = 2;
   */
  currency = "";

  /**
   * Location ID (from previous response)
   *
   * @generated from field: optional string location_id = 3;
   */
  locationId?: string;

  /**
   * Billing duration (from previous response)
   *
   * @generated from field: optional google.protobuf.Duration duration = 4;
   */
  duration?: Duration;

  /**
   * Units/slots (from previous response)
   *
   * @generated from field: optional int32 units = 5;
   */
  units?: number;

  constructor(data?: PartialMessage<GetOrderInformationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetOrderInformationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "location_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "duration", kind: "message", T: Duration, opt: true },
    { no: 5, name: "units", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrderInformationRequest {
    return new GetOrderInformationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrderInformationRequest {
    return new GetOrderInformationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrderInformationRequest {
    return new GetOrderInformationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrderInformationRequest | PlainMessage<GetOrderInformationRequest> | undefined, b: GetOrderInformationRequest | PlainMessage<GetOrderInformationRequest> | undefined): boolean {
    return proto3.util.equals(GetOrderInformationRequest, a, b);
  }
}

/**
 * Request for calculating the final checkout price.
 * Called when GetOrderInformation returns complete=true.
 * location_id and units are optional to support non-Gamecloud products (e.g. Loot Pass)
 * that have no location or unit concepts. For Gameclouds these are effectively required
 * (GetOrderInformation won't return complete=true without them).
 *
 * @generated from message gportal.api.payment.v1.GetOrderPriceRequest
 */
export class GetOrderPriceRequest extends Message<GetOrderPriceRequest> {
  /**
   * Chargebee plan ID
   *
   * @generated from field: string plan_id = 1;
   */
  planId = "";

  /**
   * ISO 4217 currency code
   *
   * @generated from field: string currency = 2;
   */
  currency = "";

  /**
   * Location ID (required for Gameclouds)
   *
   * @generated from field: optional string location_id = 3;
   */
  locationId?: string;

  /**
   * Billing duration
   *
   * @generated from field: google.protobuf.Duration duration = 4;
   */
  duration?: Duration;

  /**
   * Number of slots/units (required for Gameclouds)
   *
   * @generated from field: optional int32 units = 5;
   */
  units?: number;

  /**
   * Selected addons with per-addon quantities
   *
   * @generated from field: repeated gportal.api.payment.v1.AddonSelection addons = 6;
   */
  addons: AddonSelection[] = [];

  /**
   * Optional coupon codes
   *
   * @generated from field: repeated string coupon_codes = 7;
   */
  couponCodes: string[] = [];

  constructor(data?: PartialMessage<GetOrderPriceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetOrderPriceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "location_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "duration", kind: "message", T: Duration },
    { no: 5, name: "units", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "addons", kind: "message", T: AddonSelection, repeated: true },
    { no: 7, name: "coupon_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrderPriceRequest {
    return new GetOrderPriceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrderPriceRequest {
    return new GetOrderPriceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrderPriceRequest {
    return new GetOrderPriceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrderPriceRequest | PlainMessage<GetOrderPriceRequest> | undefined, b: GetOrderPriceRequest | PlainMessage<GetOrderPriceRequest> | undefined): boolean {
    return proto3.util.equals(GetOrderPriceRequest, a, b);
  }
}

/**
 * Request to poll the processing status of a checkout. Used by the result
 * page to determine when the subscription is fully active AND the
 * downstream provisioning (game server deploy, Loot-Pass activation, etc.)
 * has finished. Both checkout flows poll the same RPC, keyed on the
 * identifier they have:
 *   - `payment_intent_id` for the new Payment Components flow (the same
 *     ID the website passed to SubmitCheckout).
 *   - `hosted_page_id` for the legacy hosted-checkout flow (returned by
 *     CreateCheckoutURL, echoed back by Chargebee on the redirect to
 *     /checkout/result).
 *
 * @generated from message gportal.api.payment.v1.GetCheckoutStatusRequest
 */
export class GetCheckoutStatusRequest extends Message<GetCheckoutStatusRequest> {
  /**
   * @generated from oneof gportal.api.payment.v1.GetCheckoutStatusRequest.key
   */
  key: {
    /**
     * hosted_page_id keeps its original field number (1) from when this
     * request was a flat `string hosted_page_id = 1`; payment_intent_id, the
     * new Payment Components key, takes a fresh number rather than renumbering
     * an existing field.
     *
     * @generated from field: string hosted_page_id = 1;
     */
    value: string;
    case: "hostedPageId";
  } | {
    /**
     * @generated from field: string payment_intent_id = 2;
     */
    value: string;
    case: "paymentIntentId";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<GetCheckoutStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetCheckoutStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "hosted_page_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "key" },
    { no: 2, name: "payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "key" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCheckoutStatusRequest {
    return new GetCheckoutStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCheckoutStatusRequest {
    return new GetCheckoutStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCheckoutStatusRequest {
    return new GetCheckoutStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCheckoutStatusRequest | PlainMessage<GetCheckoutStatusRequest> | undefined, b: GetCheckoutStatusRequest | PlainMessage<GetCheckoutStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetCheckoutStatusRequest, a, b);
  }
}

/**
 * A single start configuration entry for price resolution.
 *
 * @generated from message gportal.api.payment.v1.StartConfigurationEntry
 */
export class StartConfigurationEntry extends Message<StartConfigurationEntry> {
  /**
   * Number of units/slots
   *
   * @generated from field: int32 units = 1;
   */
  units = 0;

  /**
   * Billing duration in days
   *
   * @generated from field: int32 duration_days = 2;
   */
  durationDays = 0;

  /**
   * Optional addons with quantities
   *
   * @generated from field: repeated gportal.api.payment.v1.AddonSelection addons = 3;
   */
  addons: AddonSelection[] = [];

  constructor(data?: PartialMessage<StartConfigurationEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.StartConfigurationEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "units", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "duration_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "addons", kind: "message", T: AddonSelection, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartConfigurationEntry {
    return new StartConfigurationEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartConfigurationEntry {
    return new StartConfigurationEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartConfigurationEntry {
    return new StartConfigurationEntry().fromJsonString(jsonString, options);
  }

  static equals(a: StartConfigurationEntry | PlainMessage<StartConfigurationEntry> | undefined, b: StartConfigurationEntry | PlainMessage<StartConfigurationEntry> | undefined): boolean {
    return proto3.util.equals(StartConfigurationEntry, a, b);
  }
}

/**
 * Request to resolve prices for a set of start configurations.
 * Public: used by the GraphQL service to populate product pricing.
 * Returns prices in all supported currencies and all locations (for Gamecloud plans).
 *
 * @generated from message gportal.api.payment.v1.GetStartConfigurationsRequest
 */
export class GetStartConfigurationsRequest extends Message<GetStartConfigurationsRequest> {
  /**
   * Chargebee plan ID (e.g. "Loot-Pass")
   *
   * @generated from field: string plan_id = 1;
   */
  planId = "";

  /**
   * @generated from field: repeated gportal.api.payment.v1.StartConfigurationEntry configurations = 2;
   */
  configurations: StartConfigurationEntry[] = [];

  constructor(data?: PartialMessage<GetStartConfigurationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetStartConfigurationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "configurations", kind: "message", T: StartConfigurationEntry, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStartConfigurationsRequest {
    return new GetStartConfigurationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStartConfigurationsRequest {
    return new GetStartConfigurationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStartConfigurationsRequest {
    return new GetStartConfigurationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStartConfigurationsRequest | PlainMessage<GetStartConfigurationsRequest> | undefined, b: GetStartConfigurationsRequest | PlainMessage<GetStartConfigurationsRequest> | undefined): boolean {
    return proto3.util.equals(GetStartConfigurationsRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.GetLootPassFreeMonthCouponRequest
 */
export class GetLootPassFreeMonthCouponRequest extends Message<GetLootPassFreeMonthCouponRequest> {
  /**
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  constructor(data?: PartialMessage<GetLootPassFreeMonthCouponRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetLootPassFreeMonthCouponRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLootPassFreeMonthCouponRequest {
    return new GetLootPassFreeMonthCouponRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLootPassFreeMonthCouponRequest {
    return new GetLootPassFreeMonthCouponRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLootPassFreeMonthCouponRequest {
    return new GetLootPassFreeMonthCouponRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLootPassFreeMonthCouponRequest | PlainMessage<GetLootPassFreeMonthCouponRequest> | undefined, b: GetLootPassFreeMonthCouponRequest | PlainMessage<GetLootPassFreeMonthCouponRequest> | undefined): boolean {
    return proto3.util.equals(GetLootPassFreeMonthCouponRequest, a, b);
  }
}

/**
 * CheckoutOrder fully describes the order configuration that produces a
 * Chargebee subscription (plan + currency + duration + units + addons +
 * coupons + Gamecloud metadata). Shared by both checkout entry points
 * (CreateCheckoutURL — legacy hosted page; CreateCheckoutPaymentIntent —
 * new inline Payment Components) and echoed back through SubmitCheckout
 * so the server can re-resolve the exact same item prices at submit time.
 *
 * @generated from message gportal.api.payment.v1.CheckoutOrder
 */
export class CheckoutOrder extends Message<CheckoutOrder> {
  /**
   * Chargebee plan ID
   *
   * @generated from field: string plan_id = 1;
   */
  planId = "";

  /**
   * ISO 4217 currency code
   *
   * @generated from field: string currency = 2;
   */
  currency = "";

  /**
   * Billing duration
   *
   * @generated from field: google.protobuf.Duration duration = 3;
   */
  duration?: Duration;

  /**
   * Number of slots/units (required for Gameclouds)
   *
   * @generated from field: optional int32 units = 4;
   */
  units?: number;

  /**
   * Additional configuration (location_key, repo_key, product_key)
   *
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string } = {};

  /**
   * Selected addons with per-addon quantities
   *
   * @generated from field: repeated gportal.api.payment.v1.AddonSelection addons = 6;
   */
  addons: AddonSelection[] = [];

  /**
   * Optional coupon codes
   *
   * @generated from field: repeated string coupon_codes = 7;
   */
  couponCodes: string[] = [];

  constructor(data?: PartialMessage<CheckoutOrder>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CheckoutOrder";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "duration", kind: "message", T: Duration },
    { no: 4, name: "units", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 6, name: "addons", kind: "message", T: AddonSelection, repeated: true },
    { no: 7, name: "coupon_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckoutOrder {
    return new CheckoutOrder().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckoutOrder {
    return new CheckoutOrder().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckoutOrder {
    return new CheckoutOrder().fromJsonString(jsonString, options);
  }

  static equals(a: CheckoutOrder | PlainMessage<CheckoutOrder> | undefined, b: CheckoutOrder | PlainMessage<CheckoutOrder> | undefined): boolean {
    return proto3.util.equals(CheckoutOrder, a, b);
  }
}

/**
 * Request to create a Chargebee hosted checkout page. Legacy entry point
 * for step 4 of checkout — gated behind the `payment-components` feature
 * flag being OFF. When the flag is ON the website calls
 * CreateCheckoutPaymentIntent + SubmitCheckout instead.
 *
 * @generated from message gportal.api.payment.v1.CreateCheckoutURLRequest
 */
export class CreateCheckoutURLRequest extends Message<CreateCheckoutURLRequest> {
  /**
   * @generated from field: gportal.api.payment.v1.CheckoutOrder order = 1;
   */
  order?: CheckoutOrder;

  constructor(data?: PartialMessage<CreateCheckoutURLRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CreateCheckoutURLRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order", kind: "message", T: CheckoutOrder },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCheckoutURLRequest {
    return new CreateCheckoutURLRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCheckoutURLRequest {
    return new CreateCheckoutURLRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCheckoutURLRequest {
    return new CreateCheckoutURLRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCheckoutURLRequest | PlainMessage<CreateCheckoutURLRequest> | undefined, b: CreateCheckoutURLRequest | PlainMessage<CreateCheckoutURLRequest> | undefined): boolean {
    return proto3.util.equals(CreateCheckoutURLRequest, a, b);
  }
}

/**
 * Request to create a Chargebee payment_intent that the website hands to
 * `chargebee.components(...).create('payment', { paymentIntent })` for
 * inline native rendering of a subscription checkout. New-flow
 * counterpart to CreateCheckoutURLRequest.
 *
 * @generated from message gportal.api.payment.v1.CreateCheckoutPaymentIntentRequest
 */
export class CreateCheckoutPaymentIntentRequest extends Message<CreateCheckoutPaymentIntentRequest> {
  /**
   * @generated from field: gportal.api.payment.v1.CheckoutOrder order = 1;
   */
  order?: CheckoutOrder;

  /**
   * Unused and ignored by the server: every method in the Payment Components
   * accordion authorizes the one method-agnostic intent this RPC creates. It
   * typed the intent for Adyen's Klarna Pay Now, which went through
   * cbInstance.handlePayment; Klarna now goes through Stripe and the accordion.
   *
   * @generated from field: string payment_method_type = 2 [deprecated = true];
   * @deprecated
   */
  paymentMethodType = "";

  constructor(data?: PartialMessage<CreateCheckoutPaymentIntentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CreateCheckoutPaymentIntentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order", kind: "message", T: CheckoutOrder },
    { no: 2, name: "payment_method_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCheckoutPaymentIntentRequest {
    return new CreateCheckoutPaymentIntentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCheckoutPaymentIntentRequest {
    return new CreateCheckoutPaymentIntentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCheckoutPaymentIntentRequest {
    return new CreateCheckoutPaymentIntentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCheckoutPaymentIntentRequest | PlainMessage<CreateCheckoutPaymentIntentRequest> | undefined, b: CreateCheckoutPaymentIntentRequest | PlainMessage<CreateCheckoutPaymentIntentRequest> | undefined): boolean {
    return proto3.util.equals(CreateCheckoutPaymentIntentRequest, a, b);
  }
}

/**
 * Request to finalize a checkout. Exactly one arm of `method` must be set:
 * `payment_intent_id` (user entered fresh payment details via
 * chargebee.components — server uses payment_intent[id] on
 * subscription_for_items), `existing_payment_source_id` (user picked a
 * previously saved Chargebee payment_source — server uses payment_source_id),
 * or `pay_with_balance` (migrated customer paying out of their Chargebee
 * account balance, no payment method involved).
 *
 * @generated from message gportal.api.payment.v1.SubmitCheckoutRequest
 */
export class SubmitCheckoutRequest extends Message<SubmitCheckoutRequest> {
  /**
   * @generated from oneof gportal.api.payment.v1.SubmitCheckoutRequest.method
   */
  method: {
    /**
     * payment_intent.id from the chargebee.components onSuccess callback.
     *
     * @generated from field: string payment_intent_id = 1;
     */
    value: string;
    case: "paymentIntentId";
  } | {
    /**
     * Chargebee payment_source.id from
     * CreateCheckoutPaymentIntentResponse.saved_payment_methods[].id.
     *
     * @generated from field: string existing_payment_source_id = 3;
     */
    value: string;
    case: "existingPaymentSourceId";
  } | {
    /**
     * Pay for this checkout entirely out of the customer's Chargebee account
     * balance — no card, no payment_intent. Set only when
     * CreateCheckoutPaymentIntentResponse.balance_covers_total was true; the
     * server re-checks coverage against Chargebee at submit, because the
     * balance can be spent between the intent and this call.
     *
     * This is an explicit arm rather than a relaxation of "one of the arms is
     * required": if the rule were relaxed, a client bug that drops the arm
     * would silently create a card-free subscription instead of failing.
     * `tracking_payment_intent_id` supplies the idempotency key.
     *
     * @generated from field: bool pay_with_balance = 6;
     */
    value: boolean;
    case: "payWithBalance";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * Echo back the order that was used to create the intent — needed
   * server-side to call subscription_for_items with the right item prices,
   * coupons, addons, units, and Gamecloud metadata.
   *
   * @generated from field: gportal.api.payment.v1.CheckoutOrder order = 2;
   */
  order?: CheckoutOrder;

  /**
   * The payment_intent CreateCheckoutPaymentIntent returned, which the
   * website is polling GetCheckoutStatus on. The server links the resulting
   * subscription to the exact checkout row that poll reads
   * (chargebee_checkouts.payment_intent_id) so the result page can flip to
   * PROCESSED. On the payment_intent_id path this duplicates the oneof value;
   * on the existing_payment_source_id (saved-method) path the oneof can't also
   * carry the intent, so it travels here. Empty only for legacy callers that
   * predate this field, where the server falls back to a customer + item-price
   * lookup.
   *
   * @generated from field: string tracking_payment_intent_id = 4;
   */
  trackingPaymentIntentId = "";

  /**
   * Proof that the user ticked the mandatory Terms & Conditions / Privacy
   * Policy checkbox shown next to the pay button. Payment Components (unlike
   * the legacy hosted page) never writes Chargebee's native consent log, so
   * this record is our evidence trail — the server persists it onto the
   * resulting subscription's meta_data. Absent only for legacy callers that
   * predate the checkbox.
   *
   * @generated from field: gportal.api.payment.v1.CheckoutConsent consent = 5;
   */
  consent?: CheckoutConsent;

  constructor(data?: PartialMessage<SubmitCheckoutRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.SubmitCheckoutRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "method" },
    { no: 3, name: "existing_payment_source_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "method" },
    { no: 6, name: "pay_with_balance", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "method" },
    { no: 2, name: "order", kind: "message", T: CheckoutOrder },
    { no: 4, name: "tracking_payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "consent", kind: "message", T: CheckoutConsent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitCheckoutRequest {
    return new SubmitCheckoutRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitCheckoutRequest {
    return new SubmitCheckoutRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitCheckoutRequest {
    return new SubmitCheckoutRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitCheckoutRequest | PlainMessage<SubmitCheckoutRequest> | undefined, b: SubmitCheckoutRequest | PlainMessage<SubmitCheckoutRequest> | undefined): boolean {
    return proto3.util.equals(SubmitCheckoutRequest, a, b);
  }
}

/**
 * CheckoutConsent captures the user's affirmative acceptance of the Terms &
 * Conditions and Privacy Policy at checkout. Stored on the subscription
 * meta_data so a later dispute can be tied to the exact document version in
 * force at acceptance time.
 *
 * @generated from message gportal.api.payment.v1.CheckoutConsent
 */
export class CheckoutConsent extends Message<CheckoutConsent> {
  /**
   * True only when the user actively ticked the consent checkbox in the UI.
   *
   * @generated from field: bool terms_accepted = 1;
   */
  termsAccepted = false;

  /**
   * Version identifier of the Terms & Conditions / Privacy Policy the user
   * accepted (the website's checkout TOS-version constant, bumped whenever
   * legal updates the documents).
   *
   * @generated from field: string terms_version = 2;
   */
  termsVersion = "";

  /**
   * Client timestamp captured the moment the box was ticked.
   *
   * @generated from field: google.protobuf.Timestamp accepted_at = 3;
   */
  acceptedAt?: Timestamp;

  constructor(data?: PartialMessage<CheckoutConsent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CheckoutConsent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "terms_accepted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "terms_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "accepted_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckoutConsent {
    return new CheckoutConsent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckoutConsent {
    return new CheckoutConsent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckoutConsent {
    return new CheckoutConsent().fromJsonString(jsonString, options);
  }

  static equals(a: CheckoutConsent | PlainMessage<CheckoutConsent> | undefined, b: CheckoutConsent | PlainMessage<CheckoutConsent> | undefined): boolean {
    return proto3.util.equals(CheckoutConsent, a, b);
  }
}

/**
 * Request to attach a Chargebee.js single-use token as a payment source
 * on the authenticated customer. Legacy "add payment method" entry point
 * gated behind the `payment-components` feature flag being OFF.
 *
 * @generated from message gportal.api.payment.v1.SetupPaymentMethodRequest
 */
export class SetupPaymentMethodRequest extends Message<SetupPaymentMethodRequest> {
  /**
   * Single-use token returned by Chargebee.js cardComponent.tokenize() in
   * the browser.
   *
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * When true (default), the new payment source becomes the customer's
   * primary payment source and the previous primary is kept as backup. Set to
   * false to add an alternate method without changing roles.
   *
   * @generated from field: optional bool replace_primary_payment_source = 2;
   */
  replacePrimaryPaymentSource?: boolean;

  constructor(data?: PartialMessage<SetupPaymentMethodRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.SetupPaymentMethodRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "replace_primary_payment_source", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetupPaymentMethodRequest {
    return new SetupPaymentMethodRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetupPaymentMethodRequest {
    return new SetupPaymentMethodRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetupPaymentMethodRequest {
    return new SetupPaymentMethodRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetupPaymentMethodRequest | PlainMessage<SetupPaymentMethodRequest> | undefined, b: SetupPaymentMethodRequest | PlainMessage<SetupPaymentMethodRequest> | undefined): boolean {
    return proto3.util.equals(SetupPaymentMethodRequest, a, b);
  }
}

/**
 * Request to create a setup intent (payment_intent with amount=0) for
 * the "add payment method" flow on the support page. No subscription
 * involved — only collecting a method.
 *
 * @generated from message gportal.api.payment.v1.CreateSetupPaymentIntentRequest
 */
export class CreateSetupPaymentIntentRequest extends Message<CreateSetupPaymentIntentRequest> {
  constructor(data?: PartialMessage<CreateSetupPaymentIntentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CreateSetupPaymentIntentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSetupPaymentIntentRequest {
    return new CreateSetupPaymentIntentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSetupPaymentIntentRequest {
    return new CreateSetupPaymentIntentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSetupPaymentIntentRequest {
    return new CreateSetupPaymentIntentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSetupPaymentIntentRequest | PlainMessage<CreateSetupPaymentIntentRequest> | undefined, b: CreateSetupPaymentIntentRequest | PlainMessage<CreateSetupPaymentIntentRequest> | undefined): boolean {
    return proto3.util.equals(CreateSetupPaymentIntentRequest, a, b);
  }
}

/**
 * Request to attach the payment method captured by a setup payment_intent
 * to the authenticated customer.
 *
 * @generated from message gportal.api.payment.v1.SubmitPaymentMethodSetupRequest
 */
export class SubmitPaymentMethodSetupRequest extends Message<SubmitPaymentMethodSetupRequest> {
  /**
   * @generated from field: string payment_intent_id = 1;
   */
  paymentIntentId = "";

  constructor(data?: PartialMessage<SubmitPaymentMethodSetupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.SubmitPaymentMethodSetupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitPaymentMethodSetupRequest {
    return new SubmitPaymentMethodSetupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitPaymentMethodSetupRequest {
    return new SubmitPaymentMethodSetupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitPaymentMethodSetupRequest {
    return new SubmitPaymentMethodSetupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitPaymentMethodSetupRequest | PlainMessage<SubmitPaymentMethodSetupRequest> | undefined, b: SubmitPaymentMethodSetupRequest | PlainMessage<SubmitPaymentMethodSetupRequest> | undefined): boolean {
    return proto3.util.equals(SubmitPaymentMethodSetupRequest, a, b);
  }
}

/**
 * Request to list a customer's saved Chargebee payment methods.
 *
 * With `customer_keycloak_id` empty the customer comes from the token — the
 * checkout's case, where the customer is signed in. With it set the request is
 * about that customer, and the same rule as GetAccountBalance applies: callers
 * without ROLE_SUPPORT may only ask about themselves, and `region` is
 * required. That is the renewal mail's case: the Webinterface cron tells a
 * migrated customer whether their renewal will be collected, with nobody
 * signed in.
 *
 * @generated from message gportal.api.payment.v1.ListSavedPaymentMethodsRequest
 */
export class ListSavedPaymentMethodsRequest extends Message<ListSavedPaymentMethodsRequest> {
  /**
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  /**
   * @generated from field: gportal.type.v1.Region region = 2;
   */
  region = Region.UNSPECIFIED;

  constructor(data?: PartialMessage<ListSavedPaymentMethodsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ListSavedPaymentMethodsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSavedPaymentMethodsRequest {
    return new ListSavedPaymentMethodsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSavedPaymentMethodsRequest {
    return new ListSavedPaymentMethodsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSavedPaymentMethodsRequest {
    return new ListSavedPaymentMethodsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSavedPaymentMethodsRequest | PlainMessage<ListSavedPaymentMethodsRequest> | undefined, b: ListSavedPaymentMethodsRequest | PlainMessage<ListSavedPaymentMethodsRequest> | undefined): boolean {
    return proto3.util.equals(ListSavedPaymentMethodsRequest, a, b);
  }
}

/**
 * Request to record an offline "excess payment" on a customer's Chargebee
 * account — the API equivalent of the manual "Record an Offline Payment"
 * action a supporter performs in the Chargebee UI. Used by the Webinterface
 * PaysafeCard → Chargebee transfer button: after the WI books the outbound
 * account-balance debit, it calls this RPC to credit the matching amount onto
 * the customer's Chargebee account (mode = Custom, custom method =
 * "Account Balance").
 *
 * @generated from message gportal.api.payment.v1.RecordOfflinePaymentRequest
 */
export class RecordOfflinePaymentRequest extends Message<RecordOfflinePaymentRequest> {
  /**
   * Customer's Keycloak UUID. Combined with `region` to build the Chargebee
   * customer id (`<uuid>_EUR` / `<uuid>_INT`).
   *
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  /**
   * Region the customer belongs to — selects the Chargebee customer id suffix
   * (_EUR / _INT) and the per-region "Account Balance" custom payment method.
   *
   * @generated from field: gportal.type.v1.Region region = 2;
   */
  region = Region.UNSPECIFIED;

  /**
   * Positive amount to record, in subunits, with its ISO 4217 currency (e.g.
   * 90 EUR-subunits for a 0,90 € top-up). Must match the currency of the WI
   * top-up being transferred.
   *
   * @generated from field: gportal.type.v1.Money amount = 3;
   */
  amount?: Money;

  /**
   * When the original payment occurred (≈ the WI top-up transaction time).
   * Recorded as the Chargebee payment date.
   *
   * @generated from field: google.protobuf.Timestamp payment_date = 4;
   */
  paymentDate?: Timestamp;

  /**
   * Webinterface payment id of the source top-up. Stored as the Chargebee
   * transaction ReferenceNumber, which both links the records and acts as the
   * idempotency key (a retry with the same reference is not double-recorded).
   *
   * @generated from field: string reference_id = 5;
   */
  referenceId = "";

  constructor(data?: PartialMessage<RecordOfflinePaymentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.RecordOfflinePaymentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
    { no: 3, name: "amount", kind: "message", T: Money },
    { no: 4, name: "payment_date", kind: "message", T: Timestamp },
    { no: 5, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RecordOfflinePaymentRequest {
    return new RecordOfflinePaymentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RecordOfflinePaymentRequest {
    return new RecordOfflinePaymentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RecordOfflinePaymentRequest {
    return new RecordOfflinePaymentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RecordOfflinePaymentRequest | PlainMessage<RecordOfflinePaymentRequest> | undefined, b: RecordOfflinePaymentRequest | PlainMessage<RecordOfflinePaymentRequest> | undefined): boolean {
    return proto3.util.equals(RecordOfflinePaymentRequest, a, b);
  }
}

/**
 * Request to credit an amount onto a customer's Chargebee account balance as
 * an excess payment. This is what a Webinterface top-up forwards once the
 * customer is migrated: the WI books the `payment` row it always booked, then
 * calls this and books the offsetting `transfer` row.
 *
 * @generated from message gportal.api.payment.v1.AddAccountBalanceRequest
 */
export class AddAccountBalanceRequest extends Message<AddAccountBalanceRequest> {
  /**
   * Customer's Keycloak UUID. Combined with `region` to build the Chargebee
   * customer id (`<uuid>_EUR` / `<uuid>_INT`).
   *
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  /**
   * Region the customer belongs to — selects the Chargebee customer id suffix
   * (_EUR / _INT) and the per-region "Account Balance" custom payment method.
   *
   * @generated from field: gportal.type.v1.Region region = 2;
   */
  region = Region.UNSPECIFIED;

  /**
   * Positive amount to credit, in subunits, with its ISO 4217 currency. Must
   * be a currency the customer's Chargebee business entity may bill.
   *
   * @generated from field: gportal.type.v1.Money amount = 3;
   */
  amount?: Money;

  /**
   * When the money was actually received (the WI top-up transaction time, or
   * the migration time for a `mig:` reference). Recorded as the Chargebee
   * payment date, so a backdated top-up reconciles into the right period.
   *
   * @generated from field: google.protobuf.Timestamp payment_date = 4;
   */
  paymentDate?: Timestamp;

  /**
   * Prefixed reference. Allowed prefixes: `mig:` (balance migration),
   * `topup:` (forwarded Webinterface top-up), `psc:` (PaysafeCard transfer).
   *
   * @generated from field: string reference_id = 5;
   */
  referenceId = "";

  /**
   * Free-text note stored on the Chargebee transaction alongside the
   * reference. Write-only — nothing reads it back, it exists so a supporter
   * looking at the Chargebee UI can see why the credit was booked.
   *
   * @generated from field: string comment = 6;
   */
  comment = "";

  constructor(data?: PartialMessage<AddAccountBalanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.AddAccountBalanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
    { no: 3, name: "amount", kind: "message", T: Money },
    { no: 4, name: "payment_date", kind: "message", T: Timestamp },
    { no: 5, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddAccountBalanceRequest {
    return new AddAccountBalanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddAccountBalanceRequest {
    return new AddAccountBalanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddAccountBalanceRequest {
    return new AddAccountBalanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddAccountBalanceRequest | PlainMessage<AddAccountBalanceRequest> | undefined, b: AddAccountBalanceRequest | PlainMessage<AddAccountBalanceRequest> | undefined): boolean {
    return proto3.util.equals(AddAccountBalanceRequest, a, b);
  }
}

/**
 * Request to spend part of a customer's Chargebee account balance on a legacy
 * Webinterface charge (a renewal interval, a modspace purchase, an order
 * edit). All-or-nothing: either the full amount is collected or the balance is
 * left untouched and the RPC fails.
 *
 * @generated from message gportal.api.payment.v1.ConsumeAccountBalanceRequest
 */
export class ConsumeAccountBalanceRequest extends Message<ConsumeAccountBalanceRequest> {
  /**
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  /**
   * @generated from field: gportal.type.v1.Region region = 2;
   */
  region = Region.UNSPECIFIED;

  /**
   * Positive amount to collect, in subunits. Sent tax-inclusive, because the
   * legacy prices this replaces (`payment_intervals.price`) are gross.
   *
   * @generated from field: gportal.type.v1.Money amount = 3;
   */
  amount?: Money;

  /**
   * Prefixed reference; the only allowed prefix is `consume:`. It must be
   * derived from committed state only (order id, interval id, unit counts) so
   * that a retry of one attempt produces a byte-identical value and two
   * genuinely different charges never collide.
   *
   * @generated from field: string reference_id = 4;
   */
  referenceId = "";

  /**
   * Line description for the one-time invoice raised against the balance.
   * Customer-visible in Chargebee.
   *
   * @generated from field: string description = 5;
   */
  description = "";

  /**
   * How far this call may go to collect. Unset means BALANCE_ONLY.
   *
   * @generated from field: gportal.api.payment.v1.CollectionMode collection_mode = 6;
   */
  collectionMode = CollectionMode.UNSPECIFIED;

  /**
   * Opaque blob describing the work this spend pays for, held so that a spend
   * whose caller-side transaction rolled back can be REPAIRED rather than only
   * refunded.
   *
   * The server never parses it and never acts on it — it is stored with the
   * claim and handed back by ListAppliedBalanceOperations. Giving this side a
   * schema for it would couple the payment API to whatever checkout is paying.
   *
   * It rides on the claim because the claim is the one thing that already
   * survives the failure: it is committed in its own transaction before any
   * Chargebee call, so "charged" and "recoverable" become a single write and
   * there is no window where the money moved and the means to repair it did
   * not land. A caller that sends nothing can still be refunded; it just
   * cannot be repaired.
   *
   * @generated from field: bytes recovery_payload = 7;
   */
  recoveryPayload = new Uint8Array(0);

  /**
   * Chargebee payment_source.id to collect from, as listed by
   * ListSavedPaymentMethods. With COLLECTION_MODE_BALANCE_THEN_PAYMENT_METHOD it
   * covers the shortfall, and empty collects that from the primary source. With
   * COLLECTION_MODE_PAYMENT_METHOD_ONLY it pays the whole amount and is
   * required. Any other mode with a value here is InvalidArgument. The source
   * must belong to the customer and be chargeable.
   *
   * Not part of the idempotency key: a retry of one reference_id replays the
   * first attempt, whichever source it names.
   *
   * @generated from field: string payment_source_id = 8;
   */
  paymentSourceId = "";

  constructor(data?: PartialMessage<ConsumeAccountBalanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ConsumeAccountBalanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
    { no: 3, name: "amount", kind: "message", T: Money },
    { no: 4, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "collection_mode", kind: "enum", T: proto3.getEnumType(CollectionMode) },
    { no: 7, name: "recovery_payload", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 8, name: "payment_source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConsumeAccountBalanceRequest {
    return new ConsumeAccountBalanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConsumeAccountBalanceRequest {
    return new ConsumeAccountBalanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConsumeAccountBalanceRequest {
    return new ConsumeAccountBalanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ConsumeAccountBalanceRequest | PlainMessage<ConsumeAccountBalanceRequest> | undefined, b: ConsumeAccountBalanceRequest | PlainMessage<ConsumeAccountBalanceRequest> | undefined): boolean {
    return proto3.util.equals(ConsumeAccountBalanceRequest, a, b);
  }
}

/**
 * Request for a customer's Chargebee balance. Callers without ROLE_SUPPORT may
 * only ask about themselves — the handler asserts the token subject matches
 * `customer_keycloak_id`.
 *
 * @generated from message gportal.api.payment.v1.GetAccountBalanceRequest
 */
export class GetAccountBalanceRequest extends Message<GetAccountBalanceRequest> {
  /**
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  /**
   * @generated from field: gportal.type.v1.Region region = 2;
   */
  region = Region.UNSPECIFIED;

  /**
   * Optional ISO 4217 filter. Empty returns every currency the customer holds
   * a bucket in; a Webinterface read gate that only cares about the customer's
   * own currency sets it to avoid reasoning about the rest.
   *
   * @generated from field: string currency_code = 3;
   */
  currencyCode = "";

  constructor(data?: PartialMessage<GetAccountBalanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetAccountBalanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
    { no: 3, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBalanceRequest {
    return new GetAccountBalanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBalanceRequest {
    return new GetAccountBalanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBalanceRequest {
    return new GetAccountBalanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBalanceRequest | PlainMessage<GetAccountBalanceRequest> | undefined, b: GetAccountBalanceRequest | PlainMessage<GetAccountBalanceRequest> | undefined): boolean {
    return proto3.util.equals(GetAccountBalanceRequest, a, b);
  }
}

/**
 * Request to grant promotional credits — the discount instrument, distinct
 * from the account balance. Supporter grants that are gifts rather than the
 * customer's own money route here.
 *
 * @generated from message gportal.api.payment.v1.AddPromotionalCreditsRequest
 */
export class AddPromotionalCreditsRequest extends Message<AddPromotionalCreditsRequest> {
  /**
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  /**
   * @generated from field: gportal.type.v1.Region region = 2;
   */
  region = Region.UNSPECIFIED;

  /**
   * @generated from field: gportal.type.v1.Money amount = 3;
   */
  amount?: Money;

  /**
   * Prefixed reference; the only allowed prefix is `promo:`.
   *
   * @generated from field: string reference_id = 4;
   */
  referenceId = "";

  /**
   * Customer-visible reason, shown on the Chargebee promotional credit entry.
   *
   * @generated from field: string description = 5;
   */
  description = "";

  /**
   * Which grant this is. Required — an unspecified grant type is refused
   * rather than defaulted, because the routing and the tax treatment differ
   * per type.
   *
   * @generated from field: gportal.api.payment.v1.GrantType grant_type = 6;
   */
  grantType = GrantType.UNSPECIFIED;

  constructor(data?: PartialMessage<AddPromotionalCreditsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.AddPromotionalCreditsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
    { no: 3, name: "amount", kind: "message", T: Money },
    { no: 4, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "grant_type", kind: "enum", T: proto3.getEnumType(GrantType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddPromotionalCreditsRequest {
    return new AddPromotionalCreditsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddPromotionalCreditsRequest {
    return new AddPromotionalCreditsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddPromotionalCreditsRequest {
    return new AddPromotionalCreditsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddPromotionalCreditsRequest | PlainMessage<AddPromotionalCreditsRequest> | undefined, b: AddPromotionalCreditsRequest | PlainMessage<AddPromotionalCreditsRequest> | undefined): boolean {
    return proto3.util.equals(AddPromotionalCreditsRequest, a, b);
  }
}

/**
 * Request to reverse an amount previously credited to the account balance.
 *
 * @generated from message gportal.api.payment.v1.ReverseAccountBalanceRequest
 */
export class ReverseAccountBalanceRequest extends Message<ReverseAccountBalanceRequest> {
  /**
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  /**
   * @generated from field: gportal.type.v1.Region region = 2;
   */
  region = Region.UNSPECIFIED;

  /**
   * Positive amount to reverse, in subunits. May be less than the original
   * credit — partial refunds are the common case.
   *
   * @generated from field: gportal.type.v1.Money amount = 3;
   */
  amount?: Money;

  /**
   * Prefixed reference for the reversal itself; the only allowed prefix is
   * `reverse:`.
   *
   * @generated from field: string reference_id = 4;
   */
  referenceId = "";

  /**
   * The `reference_id` of the credit being reversed, when it is known. It is
   * what lets the server find the offline payment and delete it outright
   * instead of issuing a credit note. Empty is legal — a chargeback arriving
   * months later has no usable link — and the server falls back to the
   * credit-note path.
   *
   * @generated from field: string original_reference_id = 5;
   */
  originalReferenceId = "";

  /**
   * @generated from field: gportal.api.payment.v1.ReversalReason reason = 6;
   */
  reason = ReversalReason.UNSPECIFIED;

  /**
   * Supporter-facing note stored on whichever Chargebee object the reversal
   * produces.
   *
   * @generated from field: string description = 7;
   */
  description = "";

  constructor(data?: PartialMessage<ReverseAccountBalanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ReverseAccountBalanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
    { no: 3, name: "amount", kind: "message", T: Money },
    { no: 4, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "original_reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "reason", kind: "enum", T: proto3.getEnumType(ReversalReason) },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReverseAccountBalanceRequest {
    return new ReverseAccountBalanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReverseAccountBalanceRequest {
    return new ReverseAccountBalanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReverseAccountBalanceRequest {
    return new ReverseAccountBalanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReverseAccountBalanceRequest | PlainMessage<ReverseAccountBalanceRequest> | undefined, b: ReverseAccountBalanceRequest | PlainMessage<ReverseAccountBalanceRequest> | undefined): boolean {
    return proto3.util.equals(ReverseAccountBalanceRequest, a, b);
  }
}

/**
 * Request to undo an applied ConsumeAccountBalance. The caller sends it only
 * after its own transaction rolled back and its ledger holds no offsetting
 * transfer for the reference — the server cannot see the caller's ledger, so
 * that check is the caller's.
 *
 * @generated from message gportal.api.payment.v1.UnwindConsumeAccountBalanceRequest
 */
export class UnwindConsumeAccountBalanceRequest extends Message<UnwindConsumeAccountBalanceRequest> {
  /**
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  /**
   * @generated from field: gportal.type.v1.Region region = 2;
   */
  region = Region.UNSPECIFIED;

  /**
   * The `reference_id` the consume was made under; only the `consume:` prefix
   * is accepted.
   *
   * @generated from field: string reference_id = 3;
   */
  referenceId = "";

  /**
   * The amount the consume was made for, in subunits. Checked against the
   * stored operation, so a reference reused for a different charge is refused
   * rather than unwound.
   *
   * @generated from field: gportal.type.v1.Money amount = 4;
   */
  amount?: Money;

  /**
   * Why the caller is unwinding, stored with the operation for whoever reads
   * it later.
   *
   * @generated from field: string reason = 5;
   */
  reason = "";

  constructor(data?: PartialMessage<UnwindConsumeAccountBalanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.UnwindConsumeAccountBalanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
    { no: 3, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "amount", kind: "message", T: Money },
    { no: 5, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnwindConsumeAccountBalanceRequest {
    return new UnwindConsumeAccountBalanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnwindConsumeAccountBalanceRequest {
    return new UnwindConsumeAccountBalanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnwindConsumeAccountBalanceRequest {
    return new UnwindConsumeAccountBalanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UnwindConsumeAccountBalanceRequest | PlainMessage<UnwindConsumeAccountBalanceRequest> | undefined, b: UnwindConsumeAccountBalanceRequest | PlainMessage<UnwindConsumeAccountBalanceRequest> | undefined): boolean {
    return proto3.util.equals(UnwindConsumeAccountBalanceRequest, a, b);
  }
}

/**
 * Request to move a customer's Webinterface account balance onto Chargebee and
 * set the one-way `balance_migrated_at` flag. Idempotent per (customer,
 * currency) under the reference `mig:<wi_customer_id>:<CURRENCY>`.
 *
 * @generated from message gportal.api.payment.v1.MigrateAccountBalanceRequest
 */
export class MigrateAccountBalanceRequest extends Message<MigrateAccountBalanceRequest> {
  /**
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  /**
   * @generated from field: gportal.type.v1.Region region = 2;
   */
  region = Region.UNSPECIFIED;

  /**
   * Report what a real run would do and write nothing — no Chargebee call, no
   * ledger row, no flag. The flag is one-way and the first production batch is
   * the only test there will ever be, so this is the rehearsal: run the batch
   * dry, read the per-currency results and the `status`, then run it for real.
   *
   * @generated from field: bool dry_run = 3;
   */
  dryRun = false;

  constructor(data?: PartialMessage<MigrateAccountBalanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.MigrateAccountBalanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
    { no: 3, name: "dry_run", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MigrateAccountBalanceRequest {
    return new MigrateAccountBalanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MigrateAccountBalanceRequest {
    return new MigrateAccountBalanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MigrateAccountBalanceRequest {
    return new MigrateAccountBalanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MigrateAccountBalanceRequest | PlainMessage<MigrateAccountBalanceRequest> | undefined, b: MigrateAccountBalanceRequest | PlainMessage<MigrateAccountBalanceRequest> | undefined): boolean {
    return proto3.util.equals(MigrateAccountBalanceRequest, a, b);
  }
}

/**
 * Request by a customer to move their OWN Webinterface account balance onto
 * Chargebee (TV-2188). Empty on purpose: the customer is the caller, taken from
 * the token, and the region is the instance's own — a field for either would be
 * one more thing to check rather than one less.
 *
 * @generated from message gportal.api.payment.v1.MigrateOwnAccountBalanceRequest
 */
export class MigrateOwnAccountBalanceRequest extends Message<MigrateOwnAccountBalanceRequest> {
  constructor(data?: PartialMessage<MigrateOwnAccountBalanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.MigrateOwnAccountBalanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MigrateOwnAccountBalanceRequest {
    return new MigrateOwnAccountBalanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MigrateOwnAccountBalanceRequest {
    return new MigrateOwnAccountBalanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MigrateOwnAccountBalanceRequest {
    return new MigrateOwnAccountBalanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MigrateOwnAccountBalanceRequest | PlainMessage<MigrateOwnAccountBalanceRequest> | undefined, b: MigrateOwnAccountBalanceRequest | PlainMessage<MigrateOwnAccountBalanceRequest> | undefined): boolean {
    return proto3.util.equals(MigrateOwnAccountBalanceRequest, a, b);
  }
}

/**
 * Request for the "move your balance" offer on a checkout (TV-2188). The order
 * is the one the checkout would submit, so the offer is measured against its
 * total; the customer is the caller.
 *
 * @generated from message gportal.api.payment.v1.GetBalanceMigrationOfferRequest
 */
export class GetBalanceMigrationOfferRequest extends Message<GetBalanceMigrationOfferRequest> {
  /**
   * @generated from field: gportal.api.payment.v1.CheckoutOrder order = 1;
   */
  order?: CheckoutOrder;

  constructor(data?: PartialMessage<GetBalanceMigrationOfferRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetBalanceMigrationOfferRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order", kind: "message", T: CheckoutOrder },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBalanceMigrationOfferRequest {
    return new GetBalanceMigrationOfferRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBalanceMigrationOfferRequest {
    return new GetBalanceMigrationOfferRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBalanceMigrationOfferRequest {
    return new GetBalanceMigrationOfferRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBalanceMigrationOfferRequest | PlainMessage<GetBalanceMigrationOfferRequest> | undefined, b: GetBalanceMigrationOfferRequest | PlainMessage<GetBalanceMigrationOfferRequest> | undefined): boolean {
    return proto3.util.equals(GetBalanceMigrationOfferRequest, a, b);
  }
}

/**
 * Request to start a newly created customer on the Chargebee balance.
 *
 * @generated from message gportal.api.payment.v1.StartNewCustomerMigrationRequest
 */
export class StartNewCustomerMigrationRequest extends Message<StartNewCustomerMigrationRequest> {
  /**
   * @generated from field: string customer_keycloak_id = 1;
   */
  customerKeycloakId = "";

  /**
   * @generated from field: gportal.type.v1.Region region = 2;
   */
  region = Region.UNSPECIFIED;

  constructor(data?: PartialMessage<StartNewCustomerMigrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.StartNewCustomerMigrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartNewCustomerMigrationRequest {
    return new StartNewCustomerMigrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartNewCustomerMigrationRequest {
    return new StartNewCustomerMigrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartNewCustomerMigrationRequest {
    return new StartNewCustomerMigrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartNewCustomerMigrationRequest | PlainMessage<StartNewCustomerMigrationRequest> | undefined, b: StartNewCustomerMigrationRequest | PlainMessage<StartNewCustomerMigrationRequest> | undefined): boolean {
    return proto3.util.equals(StartNewCustomerMigrationRequest, a, b);
  }
}

/**
 * Request for the consume operations this side has APPLIED, so that a caller
 * which owns its own ledger can find the ones that never reached it.
 *
 * mono cannot answer "settled" on its own and deliberately does not try:
 * `wi_transaction_id` is filled only on the migration path, where the
 * Webinterface's zeroing call returns the id. A consume's offsetting `transfer`
 * row is written by the Webinterface AFTER this side has returned, inside a
 * transaction this side is never told about, so the only place that knows
 * whether a consume landed locally is the ledger that would carry it. This RPC
 * therefore returns candidates, not defects, and the caller filters them.
 *
 * @generated from message gportal.api.payment.v1.ListAppliedBalanceOperationsRequest
 */
export class ListAppliedBalanceOperationsRequest extends Message<ListAppliedBalanceOperationsRequest> {
  /**
   * @generated from field: gportal.type.v1.Region region = 1;
   */
  region = Region.UNSPECIFIED;

  /**
   * Only operations applied at or after this instant. Required: the table grows
   * without bound and a caller that wants "everything" wants a report, not an
   * RPC.
   *
   * @generated from field: google.protobuf.Timestamp applied_since = 2;
   */
  appliedSince?: Timestamp;

  /**
   * Ignore anything applied within this many seconds of now. An operation that
   * has just been applied is very likely still inside the request that will
   * record it locally, and reporting it would make every healthy checkout look
   * like an orphan for the second or two it takes to commit.
   *
   * Unset and zero both get the server's default grace: they are the same on
   * the wire for a plain proto3 scalar. A caller that wants the raw set asks
   * for 1, not 0.
   *
   * @generated from field: uint32 settle_grace_seconds = 3;
   */
  settleGraceSeconds = 0;

  /**
   * Cap on rows returned, oldest first. Zero means the server's default.
   *
   * @generated from field: uint32 limit = 4;
   */
  limit = 0;

  /**
   * Omit `recovery_payload` from the response. A caller that only wants to
   * report on lost spends does not need the blobs, and they dominate the
   * response size.
   *
   * @generated from field: bool without_recovery_payload = 6;
   */
  withoutRecoveryPayload = false;

  /**
   * Optional: restrict to one customer. Empty returns every customer in the
   * region, which is what the recovery shell wants.
   *
   * @generated from field: string customer_keycloak_id = 5;
   */
  customerKeycloakId = "";

  constructor(data?: PartialMessage<ListAppliedBalanceOperationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ListAppliedBalanceOperationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "region", kind: "enum", T: proto3.getEnumType(Region) },
    { no: 2, name: "applied_since", kind: "message", T: Timestamp },
    { no: 3, name: "settle_grace_seconds", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "without_recovery_payload", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAppliedBalanceOperationsRequest {
    return new ListAppliedBalanceOperationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAppliedBalanceOperationsRequest {
    return new ListAppliedBalanceOperationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAppliedBalanceOperationsRequest {
    return new ListAppliedBalanceOperationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAppliedBalanceOperationsRequest | PlainMessage<ListAppliedBalanceOperationsRequest> | undefined, b: ListAppliedBalanceOperationsRequest | PlainMessage<ListAppliedBalanceOperationsRequest> | undefined): boolean {
    return proto3.util.equals(ListAppliedBalanceOperationsRequest, a, b);
  }
}

/**
 * The payments page's three reads (TV-2026). None of them names a customer:
 * the caller's own token resolves one, exactly as ListSubscriptions does, so
 * there is no id on the wire that could address somebody else's money.
 *
 * @generated from message gportal.api.payment.v1.ListTransactionsRequest
 */
export class ListTransactionsRequest extends Message<ListTransactionsRequest> {
  /**
   * @generated from field: gportal.type.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListTransactionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ListTransactionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTransactionsRequest {
    return new ListTransactionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTransactionsRequest {
    return new ListTransactionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTransactionsRequest {
    return new ListTransactionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListTransactionsRequest | PlainMessage<ListTransactionsRequest> | undefined, b: ListTransactionsRequest | PlainMessage<ListTransactionsRequest> | undefined): boolean {
    return proto3.util.equals(ListTransactionsRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.ListInvoicesRequest
 */
export class ListInvoicesRequest extends Message<ListInvoicesRequest> {
  /**
   * @generated from field: gportal.type.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListInvoicesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ListInvoicesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListInvoicesRequest {
    return new ListInvoicesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListInvoicesRequest {
    return new ListInvoicesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListInvoicesRequest {
    return new ListInvoicesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListInvoicesRequest | PlainMessage<ListInvoicesRequest> | undefined, b: ListInvoicesRequest | PlainMessage<ListInvoicesRequest> | undefined): boolean {
    return proto3.util.equals(ListInvoicesRequest, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.GetBillingAddressRequest
 */
export class GetBillingAddressRequest extends Message<GetBillingAddressRequest> {
  constructor(data?: PartialMessage<GetBillingAddressRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetBillingAddressRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingAddressRequest {
    return new GetBillingAddressRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingAddressRequest {
    return new GetBillingAddressRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingAddressRequest {
    return new GetBillingAddressRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingAddressRequest | PlainMessage<GetBillingAddressRequest> | undefined, b: GetBillingAddressRequest | PlainMessage<GetBillingAddressRequest> | undefined): boolean {
    return proto3.util.equals(GetBillingAddressRequest, a, b);
  }
}

